import { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getDashboardContactStatistics } from "../../utils/awsAPI";

const getCurrentTime = () => {
    const today = new Date();
    
    let hoursNum = today.getHours();
    let hoursStr = hoursNum.toString();

    let minNum = today.getMinutes();
    let minStr = minNum.toString();

    let secNum = today.getSeconds();
    let secStr = secNum.toString();

    if (hoursNum < 10) hoursStr = '0' + hoursStr;
    if (minNum < 10) minStr = '0' + minStr;
    if (secNum < 10) secStr = '0' + secStr;
    
    return `${hoursStr}:${minStr}:${secStr}`;
};

const ContactStats = () => {
    const agentSnapshot = useSelector((state:any)=>{return state.agentSlice.agentSnapshot})    
    const agentUsername = agentSnapshot?.agentData?.configuration?.username;
    const [channelType, setChannelType] = useState('All')
    const [statsData, setStatsData] = useState<any>({});
    const [percentage, setPercentage] = useState({handledPer:0, missedPer:0});
    const [timeFrame, setTimeFrame] = useState({'text': 'Today', 'value':'0d', 'localTime':getCurrentTime()});
    let missedContacts = JSON.parse(localStorage.getItem('missedContactsAgent') || '0');
    let missedChats = JSON.parse(localStorage.getItem('missedChatsAgent') || '0');
    useEffect(()=>{
        const getDashboardData = async () => {
            const contactStatisticsResponse = await getDashboardContactStatistics(agentUsername, timeFrame.value, timeFrame.localTime);
            if(channelType === "All"){
                let allStatsData:any = {}
                allStatsData.total = contactStatisticsResponse.voice.total + contactStatisticsResponse.chat.total + parseInt(missedContacts) + parseInt(missedChats)
                allStatsData.handled = contactStatisticsResponse.voice.handled + contactStatisticsResponse.chat.handled
                allStatsData.missed = parseInt(missedContacts) + parseInt(missedChats)
                allStatsData.text = 'Contacts'
                setStatsData(allStatsData)
                progressBarCalculation(allStatsData)
            } else if (channelType === "Voice") {
                let allStatsData:any = {}
                allStatsData.total = contactStatisticsResponse.voice.total + parseInt(missedContacts)
                allStatsData.handled = contactStatisticsResponse.voice.handled
                allStatsData.missed = parseInt(missedContacts)
                allStatsData.text = 'Call'
                contactStatisticsResponse.voice.text = "Call"
                setStatsData(allStatsData)
                progressBarCalculation(allStatsData)
            } else if (channelType === "Chat") { //ADD MISSED FOR CHATS
                let allStatsData:any = {}
                allStatsData.total = contactStatisticsResponse.chat.total + parseInt(missedChats)
                allStatsData.handled = contactStatisticsResponse.chat.handled
                allStatsData.missed = parseInt(missedChats)
                allStatsData.text = 'Chat'
                contactStatisticsResponse.chat.text = "Chat"
                setStatsData(allStatsData)
                progressBarCalculation(allStatsData)
            }
        }

        getDashboardData();
    },[agentUsername, channelType, timeFrame, missedContacts])

    const progressBarCalculation = (data:any) => {
        let totalPoints = data.handled + data.missed;
        let handledPer = (totalPoints) ? parseInt(((data.handled / totalPoints) * 100).toFixed(0)) : 0;
        let missedPer = (totalPoints) ? parseInt(((data.missed / totalPoints) * 100).toFixed(0)) : 0;
        setPercentage({handledPer:handledPer, missedPer:missedPer})  
    }

    const onChannelChange = (channelType:string) => {
        setChannelType(channelType)
    }

    const onSelectTimeFrame = (event:any,selectedTimeFrame:string,userLocalTime:any) => {
        setTimeFrame({'text': event.target.value, 'value':selectedTimeFrame, 'localTime':userLocalTime})
    }

    return (
        <div className="card contact-sattistcs collapse show mt-3" id="contact_satistic">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Contact statistics - agent</h6>
                <div className='d-flex'>
                    <div className="dropdown">
                        <button type="button" className={`btn btn-sm dropdown-toggle`} data-bs-toggle="dropdown">
                            {timeFrame.text}
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'0d',getCurrentTime())} } value="Today" className="dropdown-item">Today</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'1d',getCurrentTime())} } value="1 Day" className="dropdown-item">1 day</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'1w',getCurrentTime())} } value="1 Week" className="dropdown-item">1 week</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'1M',getCurrentTime())} } value="1 Month" className="dropdown-item">1 month</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="card-body height-200">
                <div className='row'>
                    <div className='col-md-4'>
                        <h6 className="card-title">Total {statsData.text}</h6>
                        <h2>{statsData.total}</h2>
                    </div>
                    <div className='col-md-4'>
                        <ul className='list-unstyled'>
                            <li><i className="fa-solid fa-circle text-primary"></i> {statsData.text} handled {statsData.handled}</li>
                            <li><i className="fa-solid fa-circle text-danger"></i> {statsData.text} missed {statsData.missed}</li>
                        </ul>
                    </div>                     
                    <div className='col-md-4'>
                        <div className="form-check">
                        <input onChange={() =>onChannelChange("All")} checked={channelType === 'All'} type="radio" className="form-check-input" value="option1" />
                        <label className="form-check-label">View all</label>
                        </div>
                        <div className="form-check">
                        <input onChange={() =>onChannelChange("Voice")} checked={channelType === 'Voice'} type="radio" className="form-check-input" value="option2" />
                        <label className="form-check-label">Call statistics</label>
                        </div>
                        <div className="form-check">
                        <input onChange={() =>onChannelChange("Chat")} checked={channelType === 'Chat'} type="radio" className="form-check-input" value="option3" />
                        <label className="form-check-label">Chat statistics</label>
                        </div>
                    </div>
                </div>
                {(percentage.handledPer !==0 || percentage.missedPer !==0 ) && <div className="row">
                     <div className="col-md-12 mt-4">
                        <ProgressBar>
                            <ProgressBar animated striped bsPrefix="Dass" now={percentage.handledPer} key={1} label={`${percentage.handledPer}%`} />
                            <ProgressBar animated striped bsPrefix="Dass" now={percentage.missedPer} key={2} label={`${percentage.missedPer}%`} />
                        </ProgressBar>
                        <ProgressBar>
                            <ProgressBar animated striped variant="primary" now={percentage.handledPer} key={1}/>
                            <ProgressBar animated striped variant="danger" now={percentage.missedPer} key={2}/>
                        </ProgressBar>
                        
                    </div>
                </div>}
            </div>
        </div>
    )
}
export default ContactStats;